import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button,
    Stack,
} from "@mui/material";

const TicketDetailsDialog = ({ open, onClose, ticketDetails }) => {
    if (!ticketDetails) return null; // don't render if no data

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth disableScrollLock>
            <DialogTitle>Ticket Details</DialogTitle>
            <DialogContent
                dividers
                sx={{
                    maxHeight: "calc(100vh - 200px)",
                    overflowY: "auto",
                    wordBreak: "break-word"
                }}
            >
                <Stack spacing={2}>
                    <Typography><strong>Menu:</strong> {ticketDetails.menu}</Typography>
                    <Typography><strong>Submenu:</strong> {ticketDetails.submenu}</Typography>
                    {/* <Typography><strong>Title:</strong> {ticketDetails.title}</Typography> */}
                    <Typography><strong>Category:</strong> {ticketDetails.category}</Typography>
                    <Typography><strong>Functionality:</strong> {ticketDetails.functionality}</Typography>
                    <Typography><strong>AL Identifier:</strong> {ticketDetails.alIdentifier}</Typography>
                    <Typography><strong>Is Ticket Created:</strong> {ticketDetails.creationStatus ? "Yes" : "No"}</Typography>
                    <Typography><strong>Ticket Number:</strong> {ticketDetails.ticketNo}</Typography>
                    <Typography><strong>Description:</strong> {ticketDetails.description}</Typography>
                    <Typography><strong>Initiated By:</strong> {ticketDetails.createdBy}</Typography>
                    <Typography><strong>Initiated Date-Time:</strong> {ticketDetails.createAt}</Typography>
                    {ticketDetails.creationStatus ? (
                        <>
                            <Typography><strong>State:</strong> {ticketDetails.state}</Typography>
                            <Typography><strong>Status:</strong> {ticketDetails.status}</Typography>
                        </>
                    ) : (
                        <Typography>
                            <strong>Error Description:</strong> {ticketDetails.errorDescription}
                        </Typography>
                    )}
                </Stack>
            </DialogContent>


            <DialogActions>
                <Button
                    onClick={onClose}
                    variant="contained"
                    sx={{ backgroundColor: "black", "&:hover": { backgroundColor: "#333" } }}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default TicketDetailsDialog;
